module.exports = __webpack_public_path__ + "static/img/s44.29aadec4.png";